// ** React Imports
import { Routes, Route } from "react-router-dom";

// ** Flix scoped styles (neutral placeholder theme)
import "src/flix/theme/flix.css";

// ** Flix pages
import Catalog from "src/flix/pages/catalog";
import Player from "src/flix/pages/player";

/******************************************************************
 * ##: FlixApp
 * Self-contained router for the hidden Flix mode (mounted at /flix/*
 * by the single connection point in src/App.js). Paths are relative to
 * /flix; all internal navigation stays inside /flix and never links
 * back to the current app.
 * @returns {JSX.Element} - the Flix nested <Routes>
 * History:
 * 22-07-2026: Created
 ******************************************************************/
const FlixApp = () => (
  <Routes>
    <Route index element={<Catalog />} />
    <Route path="courses/:course_id" element={<Player />} />
    <Route path="courses/:course_id/module/:module_id" element={<Player />} />
    <Route path="courses/:course_id/module/:module_id/:lesson_id" element={<Player />} />
    <Route path="courses/:course_id/:chapter_id/:lesson_id" element={<Player />} />
    <Route path="*" element={<Catalog />} />
  </Routes>
);

export default FlixApp;
